import React, { useEffect, useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import CallIcon from "@mui/icons-material/Call";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import XIcon from "@mui/icons-material/X";
import { useHistory } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import { logo } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const handleContact = () => {
    window.location.href = "tel:9822081419";
  };
  const handleEmail = () => {
    window.location.href = "mailto:info@kamdhenudevelopers.com";
  };
  const handleWhatsApp = () => {
    const phoneNumber = "+919822081419";
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapFooterSection", {
        opacity: 0,
        duration: 2,
        x: -500,
        scrollTrigger: {
          trigger: ".gsapFooterSection",
          scroller: "body",
          markers: false,
          start: "top 80%",
        },
      });
    }
  });

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapFooterSection2", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".gsapFooterSection2",
          scroller: "body",
          markers: false,
          start: "top 65%",
        },
      });
    }
  });

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapFooterLogo", {
        opacity: 0,
        duration: 1,
        scale: 0.5,
        y: 20,
        delay: 1,
        scrollTrigger: {
          trigger: ".gsapFooterLogo",
          scroller: "body",
          markers: false,
          start: "top 65%",
        },
      });
    }
  });

  return (
    <div
      style={{
        ...webStyle.Container,
        flexDirection: "column",
        position: "relative",
      }}
      className=" fullWidth"
    >
      <div className=" fullWidth">
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logo}
              style={webStyle.logo}
              onClick={() => {
                history.push("/");
              }}
              className="gsapFooterLogo"
            />
          </div>

          <div
            style={webStyle.childContainer2}
            className="FooterContainer gsapFooterSection"
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                textTransform: "capitalize",
              }}
              className="FooterSection"
            >
              <div style={{ display: "flex" }} className="FooterSection">
                <a
                  className="RouteOptions2"
                  href="#"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                  Home
                </a>
              </div>
              {/* <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  borderLeft: "2px solid grey",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <a
                  className="RouteOptions2"
                  href="#TableView"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                Table View
                </a>
              </div> */}
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  borderLeft: "2px solid grey",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <a
                  className="RouteOptions2"
                  href="#about-us"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                  About us{" "}
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  borderLeft: "2px solid grey",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <a
                  className="RouteOptions2"
                  href="#ourProjects"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                  Projects{" "}
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  borderLeft: "2px solid grey",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <a
                  className="RouteOptions2"
                  href="#Gallery"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                  Gallery
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  borderLeft: "2px solid grey",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <a
                  className="RouteOptions2"
                  href="#Contact-us"
                  style={{ ...webStyle.contactTitle, textDecoration: "none" }}
                >
                  Contact us
                </a>
              </div>
            </div>
          </div>
          <div
            style={webStyle.childContainer}
            className="FooterContainer gsapFooterSection"
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignContent: "center",
                justifyContent: "space-evenly",
                textTransform: "capitalize",
              }}
              className="FooterSection"
            >
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <span
                  style={{ ...webStyle.contactTitle,display:"flex",alignItems:"center",fontSize:"20px" }}
                  onClick={handleContact}
                >
                  <CallIcon style={{fontSize:"25px",marginRight:"5px"}} />
                  call us{" "}
                </span>
                <span
                  style={{ ...webStyle.contactText, marginLeft: "20px",fontSize:"16px", marginTop: "3px" }}
                  className="RouteOptions2 callUsFooter"
                  onClick={handleContact}
                >
                  +91 9822081419
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                  padding: "0px 20px",
                  borderLeft: "2px solid grey",
                  borderRight: "2px solid grey",
                }}
                className="FooterSection callUsFooter"
              >
                <span
                  style={{ ...webStyle.contactTitle,display:"flex",alignItems:"center",justifyContent:"center"  }}
                  onClick={handleWhatsApp}
                >
                  <WhatsAppIcon  style={{fontSize:"30px",marginRight:"5px"}}  />
                  Whatsapp us{" "}
                </span>
                <span
                  style={{ ...webStyle.contactText, marginLeft: "20px", marginTop: "3px" }}
                  className="RouteOptions2 callUsFooter"
                  onClick={handleWhatsApp}
                >
                  +91 9822081419
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  padding: "0px 20px",
                }}
                className="FooterSection callUsFooter"
              >
                <span
                  style={{ ...webStyle.contactTitle,display:"flex",alignItems:"center",justifyContent:"center"  }}
                  onClick={handleEmail}
                >
                  <EmailIcon  style={{fontSize:"30px",marginRight:"5px"}}  />
                  Email us{" "}
                </span>
                <span
                  style={{ ...webStyle.contactText, marginLeft: "20px", marginTop: "3px", textTransform: "none" }}
                  className="RouteOptions2 callUsFooter"
                  onClick={handleEmail}
                >
                  info@kamdhenudevelopers.com
                </span>
              </div>
              
            </div>
          </div>
          <a 
            href="https://www.google.com/maps/place/Indralok+Apartments/@18.4802708,73.8569091,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2ebf4481079c9:0x98ef7113e8641d9!8m2!3d18.4802708!4d73.8569091!16s%2Fg%2F11frntb88h?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div 
              style={{
                ...webStyle.contactText,
                marginLeft: "20px",
                marginTop: "20px",
                textTransform: "none",
                textAlign: "center",
              }} 
              className="RouteOptions2 callUsFooter gsapFooterSection"
            >
              <span style={{fontSize: "18px"}}>Office Address: </span>
              <span>Flat no 11 Indralok apt pune satara road, Near basuri hotel, Parvti Pune 411009</span>
            </div>
          </a>
          <a 
            href="https://www.google.com/maps/place/Kamdhenu+Park+Shirwal+.+%E0%A4%95%E0%A4%BE%E0%A4%AE%E0%A4%A7%E0%A5%87%E0%A4%A8%E0%A5%82+%E0%A4%AA%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%95+%E0%A4%B6%E0%A4%BF%E0%A4%B0%E0%A4%B5%E0%A4%B3/@18.1527673,73.9605722,17.5z/data=!4m6!3m5!1s0x3bc2f70079318ce5:0xd55a3b0d8b791544!8m2!3d18.1526979!4d73.9621168!16s%2Fg%2F11vm2kkwp3?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div 
              style={{
                ...webStyle.contactText,
                marginLeft: "20px",
                marginTop: "20px",
                textTransform: "none",
                textAlign: "center",
              }} 
              className="RouteOptions2 callUsFooter gsapFooterSection"
            >
              <span style={{fontSize: "18px"}}>Site Address: </span>
              <span>Gat no 1025/1, Shirval, Tal: Khandala, Dist: Satara, Pin: 412801(MH)</span>
            </div>
          </a>

        </div>
      </div>
      <p
        className="copyRightstyle"
        style={{
          ...webStyle.copyRightText,
          position: "relative",
          textAlign: "center",
        }}
      >
 © 2024 Kamdhenu Developers. All rights reserved

      </p>
    </div>
  );
};

const webStyle = {
  copyRightText: {
    width: "100%",
    paddingBottom: "30px",
    top: "150px",
    color: "grey",
    fontWeight: 400,
    fontSize: "12px",
  },
  logo: {
    width: "380px",
    margin: "60px 0 50px 0",
    cursor: "pointer",
    // border: "1px solid black",
    borderRadius: "8px",
  },
  Container: {
    height: "90vh",
    width: "100%",
    // background: `url(${footerBanner}) no-repeat center center/cover`,
    // background: "rgb(0,0,0)",
    background: "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(55,136,49,0.756827731092437) 100%)",
    color: "black",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    padding: "0px 20px",
    overflow: "hidden",
    borderTop: "3px solid black",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    color: "white",
  },
  contactTitle: {
    fontWeight: 600,
    color: "white",
    fontSize: "18px",
  },
  contactText: {
    fontWeight: 600,
    color: "white",
    cursor: "pointer",
  },
  socialMediaIcon: {
    color: "white",
    marginRight: "10px",
    fontSize: "30px",
  },
  SectionsContainer: {
    display: "flex",
    lineHeight: 1.5,
    // width: "100%",
  },
  childContainer: {
    display: "flex",
    justifyContent: "space-around",
    padding: "30px 100px 0px 100px",
  },
  childContainer2: {
    display: "flex",
    justifyContent: "center",
    padding: "30px 100px 0px 100px",
  },
};

export default Footer;
